
import { defineComponent } from 'vue';
import { useController } from '@/domain/services/Composer';
import { videoThumbnailModalController, View } from './VideoThumbnailModal.controller';
import VideoThumbnailSelector from './VideoThumbnailSelector.vue';
import ModalWrapper from '@/lib/Modal/ModalWrapper.vue';

export default defineComponent({
	components: { ModalWrapper, VideoThumbnailSelector },
	props: {
		fileToken: {
			type: String,
			required: true,
		},
		selected: {
			type: String,
			default: '',
		},
	},
	emits: ['thumbnailSelected'],
	setup: useController(videoThumbnailModalController, 'videoThumbnailModalController') as () => View,
});
